<script lang="ts">
  import BlogPost from "./../../components/blog/blog-post/index.svelte";
  import PageLayout from "../layout/PageLayout.svelte";
  import PageNotFound from "../../components/fallback/PageNotFound.svelte";

  export let blogId: string;

  let isBlogExist: boolean = true;
</script>

{#if isBlogExist}
  <PageLayout hasBgGradient={true} hasFooter={false}>
    <BlogPost {blogId} bind:isBlogExist/>
  </PageLayout>
{:else}
  <PageNotFound />
{/if}
